import "./scss/main.scss";

import "./vendor/jquery-2.2.4.min.js";

import "./vendor/jquery.magnific-popup-1.1.0.js";
import "./vendor/tweenLite-1.19.0.min.js";
import "./vendor/tweenLite.easePack-1.15.5.min.js";
import "./vendor/tweenLite.scrollTo-1.8.0.min.js";
import "./vendor/owl.carousel-2.1.0.js";
import "./vendor/isotope-3.0.1.min.js";
import "./vendor/clamp-0.5.1.js";

import "./application/utilities.js";
import "./application/modules/clamp.js";
import "./application/modules/carousels.js";
import "./application/modules/modals.js";
import { App } from "./application/app.js";

window.cache = {
  $window: $(window),
  $document: $(document),
  $html: $("html"),
  $body: $("body"),
};

// init app
window.app = new App(window);
window.app.init();

// Matomo
var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(["disableCampaignParameters"]);
  _paq.push(["setDoNotTrack", true]);
  _paq.push(["disableCookies"]);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://webanalytics.bilderderzukunft.de/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '12']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();